import { StyleSheet, View } from 'react-native'

const styles = StyleSheet.create({
  container: {
    paddingVertical: 16,
  },
})

export const RewardsComponentsActivityFeedFooterItem = () => <View style={styles.container} />
